'use client';

import dynamic from 'next/dynamic';

/**
 * Client-only loader for Coralogix RUM.
 *
 * `@coralogix/browser` is built on OpenTelemetry and pulls in
 * `@opentelemetry/instrumentation`, which depends on `require-in-the-middle` and
 * `import-in-the-middle`. Both are in Next's default `serverExternalPackages`
 * list, so Turbopack externalizes them (`require-in-the-middle-<hash>`) rather
 * than bundling. With `output: 'standalone'`, Next's file-tracing does NOT copy
 * those externals into the standalone `node_modules`, so any server-side
 * reference to them throws `Cannot find module` at render time and takes the
 * whole site down.
 *
 * RUM only ever runs in the browser, so loading the init component with
 * `ssr: false` keeps `@coralogix/browser` (and its OTel deps) out of the server
 * bundle entirely. Mount this from the root layout instead of importing
 * `CoralogixRumInit` directly — a direct import from any server-rendered module
 * reintroduces the crash.
 */
const CoralogixRumLoader = dynamic(() => import('@components/CoralogixRumInit'), { ssr: false });

export default CoralogixRumLoader;
